<template>
  <div class="newdetails">
    <div class="blank"></div>
    <div class="newdetail">
      <div class="ndtitle">{{ article.title }}</div>
      <div class="ndtips">
        {{ article.create_mode == 0 ? '作者：' : '来源：' }}{{ article.author
        }}<span>|</span>发布时间：{{ article.publish_at }}
      </div>
      <div class="ndblank"></div>
      <div
        class="ndcontent"
        :style="customCss ? customCss : ''"
        v-html="article.content"
      ></div>
      <!-- <div class="ndcontent" :style="{letterSpacing:customCss.letter_spacing+'px',lineHeight:customCss.line_height+'px'}" v-html="article.content"></div> -->
    </div>
    <div class="recnews">
      <div class="rnbox">
        <h3>推荐阅读</h3>
        <div class="newlist">
          <div
            class="new"
            v-for="(item, index) in recnews"
            :key="index"
            @click="toNewDetail(item.id)"
          >
            <!-- <div class="nimg"><img :src="item.cover_img+'?x-oss-process=image/resize,m_fixed,w_180'" alt="" style="width:180px"></div> -->
            <div
              class="csimg"
              :class="{ nimgno: !item.cover_img }"
              :style="{
                backgroundImage:
                  'url(' +
                  item.cover_img +
                  '?x-oss-process=image/resize,m_fixed,w_640)'
              }"
            ></div>
            <div class="ntips">
              <div class="ncf ndate">{{ item.updated_at }}</div>
              <div class="ntitle">{{ item.title }}</div>
              <div class="ncf ncontent">{{ item.about }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '../../utils/index'
const smoothscroll = () => {
  let top =
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    window.pageYOffset
  if (top > 0) {
    requestAnimationFrame(smoothscroll)
    window.scrollTo(0, top - top / 5)
  }
}
export default {
  data() {
    return {
      id: '',
      article: {},
      recnews: [],
      customCss: ''
    }
  },
  mounted() {
    let that = this
    window.scrollTo(0, 0)
    this.$nextTick(function() {
      window.addEventListener('scroll', that.animateTxt)
    })
    this.id = parseInt(this.$route.params.id)
    this.getNewDetail(this.id)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.animateTxt)
  },
  methods: {
    animateTxt() {
      let top =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset
      if (top <= 100) {
        this.$emit('hidenav')
      } else {
        this.$emit('shownav')
      }
    },
    toNewDetail(id) {
      this.$router.replace({ path: `/cn/newsdetail/${id}` })
      this.getNewDetail(id)
      window.scrollTo(0, 0)
      // smoothscroll()
    },
    getNewDetail(id) {
      // let that = this
      this.$source.post('/web/api/v1/article/details', { id: id }).then(res => {
        if (res.data.state === '00') {
          let article = res.data.data.article
          article.publish_at = utils.getDate(article.publish_at)
          let recnews = res.data.data.context_article
          recnews.forEach((value, index) => {
            value.updated_at = utils.getDate(value.updated_at)
            // value.content=utils.dealArticle(value.content)
          })
          this.recnews = recnews
          this.article = article
          // this.customCss=article.custom_css
          if (
            article.custom_css.letter_spacing &&
            article.custom_css.line_height
          ) {
            this.customCss = {
              letterSpacing: article.custom_css.letter_spacing + 'px',
              lineHeight: article.custom_css.line_height + 'px'
            }
          } else if (
            article.custom_css.letter_spacing &&
            !article.custom_css.line_height
          ) {
            this.customCss = {
              letterSpacing: article.custom_css.letter_spacing + 'px'
            }
          } else if (
            !article.custom_css.letter_spacing &&
            article.custom_css.line_height
          ) {
            this.customCss = {
              lineHeight: article.custom_css.line_height + 'px'
            }
          } else {
            this.customCss = ''
          }
          document.title = article.title
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../assets/css/common.less';
.newdetails {
  min-height: calc(100vh - 80px);
  .blank {
    height: 60px;
    background: #000;
  }
  .newdetail {
    padding: 60px 0;
    margin: 0 auto;
    width: 800px;
    color: #000;
    .ndtitle {
      font-size: 30px;
      color: #222;
      line-height: 30px;
      margin-bottom: 20px;
    }
    .ndtips {
      font-size: 16px;
      color: #999;
      span {
        margin: 0 10px;
      }
    }
    .ndblank {
      height: 1px;
      background: rgba(229, 229, 229, 1);
      margin: 20px 0;
    }
    // .ndcontent{
    //   font-size: 16px;
    //   color: #666;
    //   line-height: 36px;
    // }
  }
  .recnews {
    background: rgba(229, 229, 229, 0.5);
    .rnbox {
      padding: 60px 0;
      margin: 0 auto;
      width: 800px;
      h3 {
        text-align: center;
        font-size: 30px;
        height: 34px;
        line-height: 34px;
        color: #333;
        margin-bottom: 38px;
      }
      .newlist {
        margin-bottom: 33px;
        .new {
          cursor: pointer;
          padding: 40px 0 36px 0;
          border-top: 1px solid rgba(229, 229, 229, 1);
          display: flex;
          justify-content: space-between;
          // .nimg{
          //   margin-right: 20px;
          //   img{
          //     width: 180px;
          //     height: 100px;
          //   }
          // }
          .csimg {
            margin-right: 30px;
            height: 121px;
            width: 214px;
            // background-image:url(/static/img/in/kv.jpg) ;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
          }
          .ntips {
            flex: 1;
            .ncf {
              font-size: 14px;
              color: #666;
            }
            .ncontent {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              line-height: 24px;
            }
            .ntitle {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
              overflow: hidden;
              margin: 19px 0;
              line-height: 24px;
              color: #333;
              font-size: 24px;
            }
            .ntitle:hover {
              color: @colorblue;
            }
          }
        }
      }
    }
  }
}
.newdetails img {
  display: bolck;
}
</style>



// WEBPACK FOOTER //
// src/components/cn/newsdetail.vue